
import { defineComponent, onUpdated, ref } from 'vue';
export default defineComponent({
  name: 'Toast',
  props: {
    show: Boolean,
    message: String,
    type: String, // availble options: success, error, warning
  },
  emits: ['close'],
  setup(props, { emit }) {
    const displayToast = ref<boolean>(false);
    // timer for success toast, only stays for 5s
    let timer: number;
    const timerDelay = 5000;

    const onClickClose = () => {
      displayToast.value = false;
      emit('close');
    };

    const updateDisplayToast = () => {
      if (props.show) {
        displayToast.value = true;

        if (props.type === 'success') {
          clearTimeout(timer);
          timer = setTimeout(() => {
            displayToast.value = false;
            emit('close');
          }, timerDelay);
        }
      } else {
        displayToast.value = false;
      }
    };

    onUpdated(() => {
      updateDisplayToast();
    });

    return {
      displayToast,
      onClickClose,
    };
  },
});
